
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sdks/android",
      function () {
        return require("private-next-pages/events/sdks/android.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sdks/android"])
      });
    }
  